import React from 'react'
import PropTypes from 'prop-types'

export function FacebookRightColumnPreview({ data, placement, label }) {
  if (!data) return null
  const { headline, media, destination_url } = data

  return (
    <div className="feature-card-container">
      <div className="feature-card">
        <div className="fb-rc-preview__container">
          <div className="fb-rc-preview__image-wrap">
            <img
              src={media.url}
              alt={media.filename || 'ad creative'}
              className="fb-rc-preview__image"
              width={124}
              height={124}
              style={{ objectFit: 'cover' }}
            />
          </div>
          <div className="fb-rc-preview__content">
            <div className="fb-rc-preview__headline">
              {headline || ''}
            </div>
            <div className="fb-rc-preview__url" title={destination_url}>
              {destination_url || ''}
            </div>
          </div>
        </div>
      </div>
      <div className="feature-card-label">
        <span>{placement}</span>
        <span>{label}</span>
      </div>
    </div>
  )
}

FacebookRightColumnPreview.propTypes = {
  data: PropTypes.object,
  placement: PropTypes.string,
  label: PropTypes.string,
}

export default FacebookRightColumnPreview
